import React, {Fragment} from "react";
import {Button, Collapse, Dropdown, Menu, Popconfirm, Table, Typography} from "antd";
import {CopyOutlined, MoreOutlined, WhatsAppOutlined} from "@ant-design/icons";
import ModalAddCom from "../ModalAddCom";

const {Text, Title} = Typography

export class FicheTels extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.tels.length === 0 || selected.parents.length > 0) {
            return null
        }

        const columns = [
            {
                width: "20px",
                render: (col, row) => {

                    const MENU = [
                        {
                            label: <a
                                onClick={() => fiche.modalAddTel.show(selected.id, row, selected.adresses)}>Modifier</a>,
                            key: '0',
                        },
                        {
                            label: (
                                <Popconfirm
                                    title="Êtes-vous sûrs de vouloir supprimer ce numero de téléphone ?"
                                    onConfirm={() => fiche.onDelete(row.id, "tel")}
                                    okText="Oui"
                                    cancelText="Non"
                                    okType={"danger"}
                                >
                                    <Text type="danger">Supprimer</Text>
                                </Popconfirm>
                            ),
                            key: '1',
                        },
                    ]

                    return (
                        <Dropdown overlay={
                            <Menu
                                items={MENU}
                            />
                        } trigger={['click']}>
                            <Button type={"text"} icon={<MoreOutlined/>}/>
                        </Dropdown>
                    )
                }
            },
            {
                width: "20px",
                render: (col, row) => {
                    let whatsappTel = row?.number?.replace("+", "") || ""
                    if (whatsappTel.startsWith("0")) {
                        whatsappTel = "33" + whatsappTel.slice(1)
                    }
                    return (
                        <Button onClick={() => this.modalAddCom.addAppel(selected.id)} size="small" target="_blank"
                                href={"https://wa.me/" + whatsappTel}
                                style={{backgroundColor: "#25D366", color: "#FFF"}} shape={"circle"}
                                icon={<WhatsAppOutlined/>}/>
                    )
                }
            },
            {
                dataIndex: "number",
                render: (col, row) => (
                    <span>{row.type}: <a href={"tel:" + col}
                                         onClick={() => this.modalAddCom.addAppel(selected.id)}>{row.number}</a></span>
                )
            },
            {
                width: "20px",
                render: (col, row) => {
                    return (
                        <Button size="small" shape={"circle"} icon={<CopyOutlined />} onClick={() => {navigator.clipboard.writeText(row.number)}}/>
                    )
                }
            },

        ]

        return (
            <Fragment>
                <Collapse style={{marginTop: 10}}>
                    <Collapse.Panel header={"+" + selected.tels.length + " Téléphone(s)"}>
                        <Table
                            columns={columns}
                            dataSource={selected.tels}
                            showHeader={false}
                            pagination={false}
                            size={"small"}
                        />
                    </Collapse.Panel>
                </Collapse>
                <ModalAddCom getRef={(ref) => this.modalAddCom = ref} onFinish={() => fiche.getData()}/>
            </Fragment>

        )
    }
}
